import React, { useCallback, useEffect, useState } from 'react';

import { LetterTab } from 'components/GroupedList/styles';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';

import Item from './Item';
import { ShowMore } from './styles';

interface Props {
  lineGroup?: boolean;
  selectedItems?: GroupedListModel[];
  items?: GroupedListModel[];
  selectableType?: 'arrow' | 'check' | 'radio' | 'trashcan' | null;
  letter?: string;
  isSearch?: boolean;
  quantityText?: any;
  subItems?: boolean;
  onSelection: (selected: GroupedListModel) => void;
  maximumItemsCount?: number;
  hasFavorites?: boolean;
}

const GroupedItem = ({
  items,
  lineGroup,
  selectedItems,
  selectableType,
  onSelection,
  letter,
  isSearch,
  quantityText,
  subItems,
  maximumItemsCount,
  hasFavorites,
}: Props) => {
  const { t } = useStoreTranslation();

  const [showAllSelected, setShowAllSelected] = useState(false);

  const verifyIfItemIsChecked = useCallback(
    (user: GroupedListModel) => !!selectedItems?.find((selected) => selected.id === user.id),
    [selectedItems],
  );

  const length = items?.length || 0;
  const maximum = showAllSelected ? length : maximumItemsCount || length;

  useEffect(() => {
    if (!items || !maximumItemsCount) return;
    if (items.length <= maximumItemsCount) setShowAllSelected(false);
  }, [items, maximum, maximumItemsCount]);

  return (
    <>
      {(quantityText || letter) && <LetterTab>{`${isSearch ? quantityText : letter || quantityText}`}</LetterTab>}
      {items?.slice(0, maximum).map((item, index) => (
        <Item
          key={index}
          lineGroup={lineGroup}
          item={item}
          selectableType={selectableType}
          isChecked={verifyIfItemIsChecked(item)}
          onSelect={onSelection}
          subItems={subItems}
          isFavorite={hasFavorites && item.favorite}
          isDisabled={item.disabled}
        />
      ))}
      {length > maximum ? (
        <ShowMore onClick={() => setShowAllSelected(true)}>
          {t('groupedList.showMore', { count: length - maximum })}
        </ShowMore>
      ) : null}
      {showAllSelected ? (
        <ShowMore onClick={() => setShowAllSelected(false)}>{t('groupedList.showLess')}</ShowMore>
      ) : null}
    </>
  );
};

export default GroupedItem;
